<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="contentBox w">
      <div class="contentStitle">video media</div>
      <div class="contentTitle">视频媒体</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="imgBox">
          <img :src="src.qyfw" alt srcset />
        </div>
        <div class="yjh_item_text">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">云久鸿简介！</div>
          </div>
          <div class="text_content">
            深圳市云久鸿劳务派遣有限公司于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。
          </div>
          <div class="text_content">
            云久鸿始终秉持着诚信、责任、共赢、感恩的企业价值观，以用心服务，筑就行业新高度为使命，为打造值得全球信赖的就业服务平台而不懈努力。
          </div>
        </div>
      </div>
      <div class="videoItem">
        <div
          class="item"
          v-for="item in videoList"
          :key="item.id"
          @click="toDetail(item.id)"
        >
          <video
            width="400"
            height="200"
            controls
            :src="item.video_url"
            :poster="item.cover_image"
          ></video>
          <div class="itemTitle">{{ item.title }}</div>
          <div class="itemStitle">{{ item.sub_title }}</div>
        </div>
        <div class="item1"></div>
      </div>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import axios from "axios";
import src from '../../utils/assets'
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
  },
  data() {
    return {
      src:src,
      idnex: "3-3",
      videoList: [],
      form: {
        type: 1,
        category_id: 0,
        page: 1,
        limit: 15,
      },
    };
  },
  created() {
    this.getNewsList();
    // this.getNewsType();
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        path: "/newsDetails",
        query: {
          id: id,
        },
      });
    },
    getNewsList() {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/news/index", { params: _this.form })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 0) {
            _this.videoList = res.data.data.data;
            _this.total = res.data.data.total;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.yjh_item {
  margin: 100px 0;
  .imgBox {
    margin-right: 20px;
  }
  .yjh_item_text {
    margin-top: 50px;
  }
  .text_content {
    line-height: 40px;
  }
}
.videoItem {
  margin: 10px auto;
  // height: 200px;
  .item {
    float: left;
    margin-right: 6px;

    .itemTitle {
      font-size: 20px;
      line-height: 40px;
      font-weight: 700;
      padding: 5px 0;
      border: 1px solid #da261d;
      border-top: none;
      border-bottom: none;
    }
    .itemStitle {
      line-height: 14px;
      border: 1px solid #da261d;
      border-top: none;
      line-height: 30px;
    }
  }
  .item:nth-child(3n) {
    margin-right: 0;
  }
  .item1 {
    clear: both;
  }
}
</style>
